<!--
	BaseLayoutPage.svelte

	Contains the Header and Footer with a page content area in between.

	This page will load and display regardless of logged in state.
	However, the Header needs the $msalAuthStore to display the Avatar.
	The HomePage (or any current page) will require login if no sessionAccount.

	using window.addEventListener to capture click events for UserProfile
-->

<script>
	import { onMount } from 'svelte';
    import { isShowingUserProfile } from '../../stores/ScreenSettingsStore.js';
	import { AccountStore } from "../../common/account";

	// this works routes are now embedded into this BaseLayoutPage
	import Router from 'svelte-spa-router';
	import { location } from 'svelte-spa-router';			// new 11/2
	import routes from '../../common/routes.js';

	// TCARE components
    import Header from '../../components/header/Header.svelte';
    import Footer from '../../components/footer/Footer.svelte';
    import PageAlert from '../../components/common/PageAlert.svelte';


    onMount(() => {
		// console.log('BaseLayoutPage onMount:');
		// console.log('router $location:');
		// console.log($location);
    })

    const onClick = (e) => {
        if ($isShowingUserProfile) $isShowingUserProfile = false; // what is this? -vjm (toggles the User Profile)
    }

</script>


<style>
	.page-content-container {
		top: 50px;		/* below Header height */
		/* border: 1px solid red; */
	}

	:global(.app-header) {
        display: flex;
    }

    :global(.app-footer) {
        display: flex;
    }


	
    @media screen and (max-width: 600px) {
		* :global(.page-content-container) {
			top: 50px;
		}
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }
</style>

{#if $location === '/' || $location === '/landing' || $location === '/postal-results'}
	<!-- nav to the "special wide pages" which do not follow the rules -->
	<Router {routes}/>
{:else}
	<!-- all other pages slide in between the Header and Footer -->
	<div class="base-layout-page">
		<Header user={$AccountStore}/>
		<div class="page-content-container">
			<Router {routes}/>
		</div>
		<Footer />
		<PageAlert />
	</div>
{/if}


<!-- using this to show UserProfile -->
<svelte:window on:click={onClick}/>

